import React from "react";
import {
  Collapse,
  Divider,
  makeStyles,
  Paper,
  Table,
  TableBody,
  Typography
} from "@material-ui/core";
import { ThemeType } from "@theme";
import { PriceRecordOutput } from "@config_editor/ContractsPriceTemplates/Search/components/PriceRecordOutput";
import { decodeProfAoeSpec } from "@bonliva-crm/common/ConsultantSearch";
import locale from "@bonliva-crm/locale";

type Props = {
  row: any;
};

export const getLastLvlOfAOE = (aoe) => {
  return decodeProfAoeSpec(aoe)
    .filter((x) => x)
    .last();
};

export const CustomerContractPriceRow = ({ row }: Props) => {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles({});
  const toggleOpen = () => {
    setOpen(!open);
  };

  const [firstRecord] = row.records;

  return (
    <Paper className={classes.rowWrap} onClick={toggleOpen} square>
      <div className={classes.firstRow}>
        <Typography variant={"h6"} noWrap={!open} style={{ width: open ? "auto" : 220 }}>
          {getLastLvlOfAOE(row.profession)}
        </Typography>
        {firstRecord && !open && (
          <PriceRecordOutput record={firstRecord} price={row.price} />
        )}
      </div>
      <div>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Table
            className={classes.childRow}
            onClick={(e) => e.stopPropagation()}
            component="div"
          >
            <TableBody component="div">
              {row.records?.map((r, i) => (
                <PriceRecordOutput key={i} record={r} price={row.price} />
              ))}
            </TableBody>
          </Table>
          {row.highHolidays && (
            <div className={classes.holidayWrap}>
              <Typography>
                <b>{locale.NormalHoliday}: </b>
                {row.highHolidays
                  .filter((x) => x.isGreatHoliday === false)
                  .map(({ option }) => locale.highHolidaysList[option.name])
                  .join(", ")}
              </Typography>
              <Divider />
              <Typography>
                <b>{locale.GreatHoliday}: </b>
                {row.highHolidays
                  .filter((x) => x.isGreatHoliday)
                  .map(({ option }) => locale.highHolidaysList[option.name])
                  .join(", ")}
              </Typography>
            </div>
          )}
        </Collapse>
      </div>
    </Paper>
  );
};

const useStyles = makeStyles((theme: ThemeType) => ({
  rowWrap: {
    width: "100%",
    marginBottom: 5
  },
  firstRow: {
    width: "100%",
    display: "flex",
    padding: "5px 15px",
    justifyContent: "space-between",
    alignItems: "center",
    height: 60
  },
  btnWrap: {
    marginBottom: 5
  },
  childRow: {
    background: "#eee"
  },
  holidayWrap: {
    padding: "5px 15px"
  }
}));
